import Name from 'models/name';

/**
 * User's model
 * @param {string} email - Email of the user
 * @param {string} first_name - First name of the user
 * @param {boolean} is_staff - if the user is a staff' member
 * @param {boolean} is_superuser - if the user is a superuser' member
 * @param {string} last_name - Last name of the user
 * @param {array} user_roles - Array with all the roles
 * @param {string} username - Unique id of the user
 * @returns {Class} - User's Model
 */
export default class User {
	constructor({
		email,
		first_name: firstName,
		last_name: lastName,
		user_roles: userRoles,
		username
	} = {}) {
		this._email = email || "";
		this._name = new Name(firstName, lastName);
		this._userRoles = userRoles || [];
		this._username = username;
	}

	getKey() {
		return this._username;
	}

	getEmail() {
		return this._email;
	}

	getRoles() {
		return this._userRoles;
	}

	getUsername() {
		return this._username;
	}

	getName() {
		return this._name;
	}
}
